import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';

// @mui material components
import { ThemeProvider, CssBaseline } from '@mui/material';

// theme
import theme from 'assets/theme';

// store
import store from 'store';
import { Provider } from 'react-redux';
import { SideBarNavigationProvider } from 'utils/sideBarRoutes';
import UserProvider from 'UserProvider';
// CKey-112 : Global session with JWT token
import { jwtDecode } from "jwt-decode";

const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get('token');

if (token) {
  try {
    const decoded = jwtDecode(token);
    // CKey-112
    const { userId, username, userEmail, activityInstance, activityID, navigation } = {
      userId: decoded?.userid,
      username: decoded?.username,
      userEmail: decoded?.email,
      activityInstance: decoded?.course,
      activityID: decoded?.instance,
      navigation: decoded?.navigation  //CKey-112 : V2
    };

    const existingToken = sessionStorage.getItem("jswtoken");

    // Only clear if NEW token
    if (token !== existingToken) {
      localStorage.clear();
      sessionStorage.clear();
    }

    // Store values
    sessionStorage.setItem('activityInstance', activityInstance);
    sessionStorage.setItem('userid', userId);
    sessionStorage.setItem('username', username);
    sessionStorage.setItem('userEmail', userEmail);
    sessionStorage.setItem('activityID', activityID);
    sessionStorage.setItem('navigation', navigation); //CKey-112 : V2
    sessionStorage.setItem('jswtoken', token);

    localStorage.setItem('userid', userId);
    localStorage.setItem('username', username);
    localStorage.setItem('userEmail', userEmail);
    localStorage.setItem('activityID', activityID);
    localStorage.setItem('courseIdselected', activityInstance);

    // Clean URL AFTER storing
    window.history.replaceState({}, document.title, window.location.pathname);

  } catch (e) {
    console.error("Token decode failed", e);
    sessionStorage.clear();
  }
} else { // CKey-112
  if(token === null){
    sessionStorage.setItem('navigation', 'true');
  }
}

const ReactApp = () => (
  <Provider store={store}>
    <UserProvider>
      <SideBarNavigationProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router>
            <App />
          </Router>
        </ThemeProvider>
      </SideBarNavigationProvider>
    </UserProvider>
  </Provider>
);

ReactDOM.render(
  <React.StrictMode>
    <ReactApp />
  </React.StrictMode>,
  document.getElementById('root')
);
